import { CollapseProps, Descriptions, Grid, Tag, Typography } from 'antd';
import Parser from 'html-react-parser';
import { Fragment, useContext } from 'react';
import CollapseCustom from 'src/components/v2/Collapse';
import { TicketDetailContext } from 'src/contexts/ticketDetail.context';
import { TicketStatus, ITicket } from 'src/types/helpdesk/ticket.type';
import { FlatItem } from 'src/types/elements.type';

import './TicketDetail.scss';
import { formatDateTime } from 'src/utils/utils';
import { IAssignLog } from 'src/types/helpdesk/processTree.type';
const { Text } = Typography;

const renderStatus = (ticketStatus: FlatItem, isCurrent: boolean) => {
  if (Boolean(ticketStatus && ticketStatus.id === TicketStatus.HandleCompleted) && isCurrent) {
    return <Tag color={'blue'}>Đã xử lý hoàn thành</Tag>;
  }
  if (Boolean(ticketStatus && ticketStatus.id === TicketStatus.Finished) && isCurrent) {
    return <Tag color={'green'}>Đã hoàn tất</Tag>;
  }
  if (isCurrent) {
    return <Tag color={'green'}>Đang xử lý</Tag>;
  } else {
    return <Tag color={'red'}>Đã từ chối</Tag>;
  }
};

const assignLogItems = (assignLogs: IAssignLog[], ticket: ITicket, colspan: number): CollapseProps['items'] => {
  return assignLogs?.map((item, index) => ({
    key: index,
    label: (
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
        key={index}
      >
        <Descriptions.Item label='Người xử lý'>
          <Text strong>{item?.handler?.fullName}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Trạng thái'>
          <Text>{renderStatus(ticket.ticketStatus, item.isCurrent as boolean)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Người chỉ định'>
          <Text strong>{item.assigner?.fullName}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ngày chỉ định'>
          <Text>{formatDateTime(item.logAt)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label={'Ghi chú xử lý hoàn thành'} span={colspan}>
          <Text strong italic>
            {Parser(item?.noteComplete ?? '')}
          </Text>
        </Descriptions.Item>
        {item.isNotConfirm && (
          <Descriptions.Item label={'Lý do không hài lòng'} span={colspan}>
            <Text strong italic>
              {Parser(item?.noteReject ?? '')}
            </Text>
          </Descriptions.Item>
        )}
      </Descriptions>
    ),
    showArrow: false,
    className: 'assign-log-item'
  }));
};

const TicketDetailAssign = (): JSX.Element => {
  const { ticket } = useContext(TicketDetailContext);

  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const colspan = breakpoints.xxl ? 2 : 1;

  const dataSource = [...(ticket?.data.assignLogs ?? [])];

  return (
    <Fragment>
      {dataSource && dataSource.length > 0 && (
        <CollapseCustom
          isFullDefault
          title='Danh sách phân công'
          titleLevel={5}
          collapsible='disabled'
          isSegmented={false}
          items={assignLogItems(dataSource || [], ticket?.data as ITicket, colspan)}
          expandIconPosition='end'
          className='assign-log-collapse'
        />
      )}
    </Fragment>
  );
};
export default TicketDetailAssign;
